<template>
  <div v-if="modelValue !== null" class="row renewal">
    <div class="small-2 medium-1 columns align-self-middle">
      <span class="icon icon-info" />
    </div>
    <div
      class="small-10 medium-11 columns"
      v-html="text"
    />
  </div>
</template>

<script>
export default {
    name: 'Renewal',
    props: {
        modelValue: {
            type: Object,
            default() {
                return null;
            }
        }
    },
    computed: {
        editMode() {
            return this.$store.state.policy.editMode;
        },
        text() {
            if (this.editMode) {
                return this.modelValue?.EditModeText;
            }

            return this.modelValue?.StaticModeText;
        }
    }
};
</script>
